export const colours = {
	primary: '#03527D',
	secondary: '#013B5A',
	tertiary: '#FFE7AE',
	light: '#F8F8F8',
	dark: '#454545',
}
